export default __webpack_public_path__ + "static/media/navbar-templates-orange.94e90d04.svg";